export const SOURCES = {
  registration: 'registration',
  wizard: 'wizard',
  profile: 'profile',
};
